import { FC, ReactElement } from 'react';

import { Card } from '../../components';
import { IconButton } from '../../compositions';
import { clearCaches } from '../../helpers/reload';
import trans from '../../helpers/trans';
import { MaintenanceIllustration } from './subcomponents';

import './Maintenance.scss';

interface MaintenanceProps {
    className?: string;
}

const Maintenance: FC<MaintenanceProps> = ({
    className = '',
}): ReactElement => (
    <div className={`maintenance ${className}`}>
        <Card className="maintenance__card">
            <MaintenanceIllustration className="maintenance__illustration" />

            <h2 className="maintenance__title">
                {trans('containers.maintenance.title')}
            </h2>

            <p className="maintenance__description">
                {trans('containers.maintenance.description')}
            </p>

            <IconButton
                icon="refresh"
                text={trans('containers.maintenance.buttonLabel')}
                onClick={clearCaches}
                className="maintenance__button-refresh"
            />
        </Card>
    </div>
);

export default Maintenance;
